import ServiceApi from "../ServiceApi";
import UtilResponseException from "../../utils/UtilResponseException";
/** Сервис для управление интеграцией Telegram */
export default class ServiceIntegrationTelegram {

    /**
     * Название микросервиса для запросов
     * @private
     * @static
     * @type {String}
     */
    static _microserviceName = 'free';

    /**
     * Маршруты для запросов
     * @private
     * @static
     * @type {Object}
     * @property {String} tgNotifyList
     * @property {String} tgNotifyCreate
     */
    static _requestRouts = {
        tgAccountList: '/tg-notify/list',
        tgAccountCreate: '/tg-notify/create',
        tgAccountUpdate: '/tg-notify/update',
        tgAccountDelete: '/tg-notify/delete'
    };

    static async getTgAccountList() {
        try {
            const response = await ServiceApi.get(this._microserviceName, this._requestRouts.tgAccountList);
            const {data:  {data: accountList = []} = {} } = response;
            return this._tgAccountListAfter(accountList);
        } catch(error) {
            console.log(error);
        }
    }

    static async updateTgAccount(body) {
        try {
            return await ServiceApi.put(
                this._microserviceName,
                this._requestRouts.tgAccountUpdate,
                this._tgAccountBefore(body)
            );
        } catch(error) {
            console.log(error);
            throw new Error(UtilResponseException.getMessage(error));
        }
    }

    static async deleteTgAccount(accountId) {
        try {
            return await ServiceApi.delete(this._microserviceName, this._requestRouts.tgAccountDelete + `/${accountId}`);
        } catch(error) {
            console.log(error);
            throw new Error(UtilResponseException.getMessage(error));
        }
    }

    static async createTgAccount(body) {
        try {
            const response = await ServiceApi.post(
                this._microserviceName,
                this._requestRouts.tgAccountCreate,
                this._tgAccountBefore(body)
            );
            const {data:  {data: account = {}} = {} } = response;
            return this._tgAccountAfter(account);
        } catch(error) {
            console.log(error);
            throw new Error(UtilResponseException.getMessage(error));
        }
    }

    static _tgAccountBefore(body) {
        const {apiKey = null, secretKey = null, comment = null, id = null} = body;
        return {
            api_key: apiKey,
            secret_key: secretKey,
            comment,
            account_id: id
        };
    }

    static _tgAccountListAfter(items) {
        return items.map(ServiceIntegrationTelegram._tgAccountAfter);
    }

    static _tgAccountAfter(item) {
        const {id = null, api_key: apiKey = null, secret_key: secretKey = null, comment = null} = item;
        return {id, apiKey, secretKey, comment};
    }

}
